import * as React from "react";
import styled from "styled-components";
import { IframeHTMLAttributes, useState } from "react";
import { Box, Loading } from "../";

const IframeContent = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

type Props = React.IframeHTMLAttributes<HTMLIFrameElement>;

export const IframeLoader: React.FC<Props> = ({
  src,
  onLoad = () => {},
  ...props
}) => {
  const [isLoading, setLoading] = useState(true);

  const onLoaded = (event: any) => {
    setLoading(false);
    onLoad!(event);
  };

  return (
    <Box style={{ height: "100%" }}>
      {isLoading && <Loading />}
      <IframeContent
        src={src}
        onLoad={onLoaded}
        style={{ display: isLoading ? "none" : "block" }}
        {...props}
      />
    </Box>
  );
};
